/**
 * デバッグ用フラグ
 * テスト完了後は全フラグを false に戻すこと
 */

/** true にするとキーワード・アシスト入力のAPIエラーパスを強制的に実行する */
export const FORCE_API_ERROR = false;
